import React from 'react';

import {inherentRiskTypes} from '../../../../../util/uiconstants';

import RelatedRiskIndicator from '../../../RelatedRiskIndicator';

export default (id, label) => ({
	id,
	label,
	propName: 'name',
	width: 'var(--px-75)',
	align: 'center',
	headerAlign: 'center',
	customCell: ({assertions}) => {
		const findAssertion = (assertion) => assertion.assertionAbbreviation === label;

		const props = {
			isRiskAssertion: true
		};

		const foundAssertion = assertions.find(findAssertion);
		if (foundAssertion?.inherentRiskTypeId !== null)
			props.relatedRisk = inherentRiskTypes[foundAssertion?.inherentRiskTypeId];

		return <RelatedRiskIndicator {...props} />;
	}
});
